import { Component } from '@angular/core'
import { CurrentProductService } from '@spartacus/storefront'
import { MbProductTabApplicationsConnector } from '../../../connectors'
import { distinctUntilChanged, filter, map, switchMap, tap } from 'rxjs/operators'
import { isNotNullable } from '@spartacus/core'
import { MbProductTabApplications } from '../../../../models'

@Component({
  selector: 'mb-pdp-applications-tab',
  templateUrl: './pdp-applications-tab.component.html',
  styleUrls: ['./pdp-applications-tab.component.scss']
})
export class PdpApplicationsTabComponent {

  productName: string | undefined
  product$ = this.currentProductService.getProduct().pipe(
    filter(isNotNullable),
  )
  applications$ = this.product$.pipe(
    tap(p => this.productName = p?.nameHtml),
    map(p => p.originalCode),
    filter(isNotNullable),
    distinctUntilChanged(),
    switchMap(productCode => this.mbProductTabApplicationsConnector.get(productCode))
  )

  constructor (protected currentProductService: CurrentProductService,
              protected mbProductTabApplicationsConnector: MbProductTabApplicationsConnector) {
  }

  sortBySortOrder (applications: MbProductTabApplications[]) {
    return applications.sort((a, b) =>
      a.sortOrder && b.sortOrder && a.sortOrder - b.sortOrder || 0)
  }
}
